import React, { useEffect, useState, useRef } from 'react';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import { useNavigate, useLocation } from "react-router-dom";
import Moment from 'moment';
import { dateWithNoTimezone } from '../Helpers/DateFormat';
import { Empty, Spin, Alert, Table, Input, Button, Modal, Select, message } from 'antd';
import ShowDetailSliderVO from './ShowDetailSliderVO';
import ShowDetailSlider from './ShowDetailSlider';
import SelectShowModal from '../Helpers/SelectShowModal';
import ShowLogisticsSlider from '../Shows/ShowLogisticsSlider';
import ReactLoading from 'react-loading';
import { Fragment } from 'react';
import { useForm, Controller } from "react-hook-form";
import { addShowInterest, convertInterested, updateSalesStatus, processSalesOrder } from '../../services/ShowDetailService';
import { DeleteOutlined, EditOutlined, DollarOutlined, UserOutlined, PictureOutlined, CarOutlined } from '@ant-design/icons';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { useRecoilState, useRecoilValue } from 'recoil';
import Card from 'react-bootstrap/Card';
import ExhibitorBadgesSlider from './ExhibitorBadgesSlider';
import ShowARDetailsSlider from './ShowARDetailsSlider';

export default function ShowDetailInfo(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [state, setState] = useState({
        selectedCustomerId: props.selectedCustomerId,
        dataLoaded: false,
        selectedCustomer: {},
        shows: [],
        filteredShows: [],
        selectedShowCode: null,
        selectedShowName: '',
        totalYesShows: '',
        totalCancelShows: '',
        totalNoShows: '',
        totalOtherShows: '',
        totalShows: '',
        firstShow: '',
        showShowDetailSlider: false,
        leadsList: [],
        searchValue: '',
        showSelectShowModal: false,
        modalTitle: '',
        showConvertInterestedShowModal: false,
        showChangeShowStatusModal: false,
        exhibitorType: '',
        mainContact: '',
        lrFreeOrCharge: '',
        fpFreeOrCharge: '',
        nslFreeOrCharge: '',
        selectedShowInvoiced: false,
        selectedContactName: '',
        showShowLogisticsSlider: false,
        showShowBadgesSlider: false,
        badgesSliderCallingComponent: '',
        showShowARDetailsSlider: false
    });

    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const { register, getValues, setValue, control, watch } = useForm();
    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);
    const [selectedModelAfterRowKeys, setSelectedModelAfterRowKeys] = useState(['']);
    const [shows, setShows] = useState([]);
    const [filteredShows, setfilteredShows] = useState([]);
    const [yesShows, setYesShows] = useState([]);
    const [viewOnly, setViewOnly] = useState([]);
    const [previousShowName, setPreviousShowName] = useState('');
    const { Option } = Select;
    const [contactsListData, setContactsListData] = useState([]);
    const [alreadyClosed, setAlreadyClosed] = useState(false);

    var urlend = window.api.slice(-1) === '/' ? 'hubs/shows' : '/hubs/shows';
    const url = window.api + urlend;

    const connection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Error)
        .withUrl(url)
        .withAutomaticReconnect()
        .build();

    // Watch the salesstatus field
    const salesStatus = watch("formFields.changestatus.salesstatus");

    useEffect(() => {
        /*console.log(props.selectedCustomerName);*/
    }, []);

    useEffect(() => {
        setContactsListData(props.contacts);

        if (userInfo.userType === 'admin') {
            setViewOnly(false);
        }
        else {
            setViewOnly(true);
        }

        //this is for changing sales statuses
        LoadServiceCategories();

        getCustomerShows(props.selectedCustomerId);

        const joinedCustId = props.selectedCustomerId;

        connection.start()
            .then(async () => {
                connection.on('UpdateShowList', custId => {
                    if (Number(custId) === Number(props.selectedCustomerId)) {
                        console.log('oh I am trying');

                        getCustomerShows(props.selectedCustomerId);
                    }
                });

                await connection.invoke('JoinShowList', joinedCustId);
            })
            .catch(e => {
                console.log("SignalR Error!");
                console.log('Connection failed: ', e);
            });

        return () => {
            connection.invoke('LeaveShowList', joinedCustId).catch(() => {});
        };
    }, [props]);

    function getCustomerShows(id) {
        //console.log(state.showShowDetailSlider);

        let postdata = {};
        postdata.company_id = id;
        Axios.post(`/api/GetCustomerShows`, postdata
        ).then(response => {
            const shows = response.data;

            if (state.selectedshow === "" & shows.length > 0) {
                var selectedshow = state.shows[0];

                setState({ ...state, selectedshow });
            }

            let myYesShowsArray = [];
            var totalYesShows = 0;
            var totalCancelShows = 0;
            var totalNoShows = 0;
            var totalOtherShows = 0;
            var totalShows = 0;
            var firstShow = "";

            for (let i = 0; i < shows.length; i++) {
                // loop through your data
                if (shows[i].salesstatus === 'Yes') {
                    totalYesShows += 1;

                    myYesShowsArray.push(shows[i]);
                }
                else if (shows[i].salesstatus === 'Cancel') {
                    totalCancelShows += 1;
                }
                else if (shows[i].salesstatus === 'No') {
                    totalNoShows += 1;
                }
                else {
                    totalOtherShows += 1;
                }
                totalShows += 1;

                if (i === (shows.length - 1)) {
                    var mystartdate = new Date(shows[i].startdate);
                    var myCurrentYear = new Date().getFullYear();

                    firstShow = mystartdate.getFullYear() + ' (' + (myCurrentYear - mystartdate.getFullYear()) + ' years)';
                }
            }

            setShows(shows);
            setfilteredShows(shows);
            setYesShows(myYesShowsArray);

            setState({
                ...state,
                totalYesShows: totalYesShows,
                totalCancelShows: totalCancelShows,
                totalNoShows: totalNoShows,
                totalOtherShows: totalOtherShows,
                totalShows: totalShows,
                firstShow: firstShow,
                shows,
                dataLoaded: true,
                showShowDetailSlider: false,
                showSelectShowModal: false,
                showConvertInterestedShowModal: false
            });

        }).catch(error => {
            console.log(error);
        });
    }

    function renderBooths(record) {
        const booths = [record.booth1, record.booth2, record.booth3, record.booth4];

        return booths
            .filter(b => b !== null && b !== "")  // also excludes ""
            .join(", ");
    }

    //function renderBooths(record) {
    //    let myBooths = "";

    //    if (record.booth1 !== null) {
    //        myBooths += record.booth1 + ", ";
    //    }
    //    if (record.booth2 !== null) {
    //        myBooths += record.booth2 + ", ";
    //    }
    //    if (record.booth3 !== null) {
    //        myBooths += record.booth3 + ", ";
    //    }
    //    if (record.booth4 !== null) {
    //        myBooths += record.booth4 + ", ";
    //    }

    //    if (myBooths !== "") {
    //        myBooths = myBooths.slice(0, -2);
    //    }

    //    return myBooths;
    //}
        
     const columns = [
        {
            dataIndex: 'showcode',
            title: 'showcode',
            key: 'showcode',
            hidden: true
         }, {
             dataIndex: 'invoiced',
             title: 'invoiced',
             key: 'invoiced',
             hidden: true
        }, {
            dataIndex: 'name',
            title: 'Show',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name)
        }, {
            dataIndex: 'salesstatus',
            title: 'Status',
            key: 'salesstatus',
            sorter: (a, b) => {
                if (a && a.salesstatus && a.salesstatus.length && b && b.salesstatus && b.salesstatus.length) {
                    return a.salesstatus.length - b.salesstatus.length;
                } else if (a && a.salesstatus && a.salesstatus.length) {
                     // That means be has null salesstatus, so a will come first.
                     return -1;
                } else if (b && b.salesstatus && b.salesstatus.length) {
                     // That means a has null salesstatus so b will come first.
                     return 1;
                 }

                 // Both salesstatus has null value so there will be no order change.
                 return 0;
             },
             align: 'center'
        }, {
            dataIndex: 'startdate',
            title: 'Show Date',
            key: 'startdate',
            width: 120,
            sorter: (a, b) => new Date(a.startdate) - new Date(b.startdate),
            render: (startdate) => {
                return (
                    <div>
                        {startdate === null ? '' : Moment(dateWithNoTimezone(startdate)).format("L")}
                    </div>
                );
            }
        }, {
            title: 'Booth(s)',
            key: 'booth1',
            render: (record) => (
                renderBooths(record)),
            sorter: (a, b) => {
                if (a && a.booth1 && a.booth1.length && b && b.booth1 && b.booth1.length) {
                    return a.booth1.length - b.booth1.length;
                } else if (a && a.booth1 && a.booth1.length) {
                     // That means be has null booth1, so a will come first.
                     return -1;
                } else if (b && b.booth1 && b.booth1.length) {
                     // That means a has null booth1 so b will come first.
                     return 1;
                 }

                 // Both booth1 has null value so there will be no order change.
                 return 0;
             },
             align: 'center'
         }, {
             dataIndex: 'featuredpackage',
             title: 'Featured Pkg',
             key: 'featuredpackage',
             render: (featuredpackage) => (
                 featuredpackage !== null && (featuredpackage === 'Yes' || featuredpackage === 'True' || featuredpackage === 1) ? <span>&#10003;</span> : <span>&nbsp;</span>
             ),
             align: 'center'
        }, {
            dataIndex: 'prereglist',
            title: 'PreReg List',
            key: 'prereglist',
            render: (prereglist) => (
                prereglist !== null && (prereglist === 'Yes' || prereglist === 'True' || prereglist === 1) ? <span>&#10003;</span> : <span>&nbsp;</span>
            ),
            align: 'center'
        }, {
            dataIndex: 'weblink',
            title: 'Web Link',
            key: 'weblink',
            render: (weblink) => (
                weblink !== null && (weblink === 'Yes' || weblink === 'True' || weblink === 1) ? <span>&#10003;</span> : <span>&nbsp;</span>
            ),
            align: 'center'
        }, {
            dataIndex: 'leadretrievalstatus',
            title: 'Lead Retrieval',
            key: 'leadretrievalstatus',
            render: (leadretrievalstatus) => (
                leadretrievalstatus !== null && (leadretrievalstatus === 'Yes' || leadretrievalstatus === 'True' || leadretrievalstatus === 1) ? <span>&#10003;</span> : <span>&nbsp;</span>
            ),
            align: 'center'
        }, {
            dataIndex: 'caravanfreight',
            title: 'Caravan',
            key: 'caravanfreight',
             render: (caravanfreight) => (
                 caravanfreight !== null && (caravanfreight === 'Yes' || caravanfreight === 'True' || caravanfreight === 1) ? <span>&#10003;</span> : <span>&nbsp;</span>
            ),
            align: 'center'
        }, {
            title: 'Edit Show Info',
            key: 'action',
            width: 120,
            render: (record) => (
                 (viewOnly && record.salesstatus !== 'Interested') || viewOnly === false ? <EditOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} onClick={(e) => loadShowDetails(e, record)} /> : <span>&nbsp;</span>
            ),
            //render: (record) => (
            //    <span className="hover" onClick={(e) => loadShowDetails(e, record)}><i id="showDetails" className="fas fa-edit fa-1x ml-3 text-center hover"></i></span>
            //),
             align: 'center'
         }, {
             title: 'Show Logistics',
             key: 'action',
             width: 120,
             render: (record) => (
                 <CarOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} onClick={(e) => loadShowLogistics(e, record)} />
             ),
             align: 'center'
        }, {
            title: 'AR Details',
            key: 'action',
            width: 120,
            align: 'center',
            hidden: viewOnly,
            render: (_, record) =>
                record.salesstatus === 'Yes' ? (
                    <DollarOutlined
                        className="text-center hover"
                        style={{ fontSize: '1.2rem' }}
                        onClick={(e) => loadARDetails(e, record)}
                    />
                 ) : null
         //}, {
         //    title: 'Booth Furnishings',
         //    key: 'action',
         //    width: 120,
         //    render: (record) => (
         //        <PictureOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} onClick={(e) => loadBoothFurnishings(e, record)} />
         //    ),
         //    align: 'center',
         //    hidden: viewOnly
         }, {
             title: 'Show Badges',
             key: 'action',
             width: 120,
             render: (record) => (
                 record.salesstatus === 'Yes' ? (<UserOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} onClick={(e) => loadShowBadgesSlider(e, record)} />) : null
             ),
             //render: (record) => (
             //    <UserOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} onClick={(e) => loadShowBadgesSlider(e, record)} />
             //),
             align: 'center',
             hidden: viewOnly
        }, {
            dataIndex: 'leadscollected',
            title: 'Leads Collected',
            key: 'leadscollected',
            render: (leadscollected, record) => (
                leadscollected > 0 ? <span className="hover" onClick={(e) => handleExportLeads(e, record)}>< i id="leadsDownload" className="fas fa-download fa-1x ml-3 text-center hover"></i > { leadscollected.toString() } leads</span > : <span />
            ),
            align: 'center'
        }
    ].filter(item => !item.hidden);

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function renderModelAfterLR(record) {
        var myLRText;

        if (record.leadretrievalstatus !== null && record.leadretrievalstatus.toUpperCase() === 'YES') {
            myLRText = 'LR: ' + USDollar.format(record.leadretrievalamount);
        }
        else {
            myLRText = 'LR: NO';
        }

        return myLRText;
    }

    function renderModelAfterPackageDetails(record) {
        var myPkgText;

        myPkgText = record.packagetype;

        if (record.packagetype !== null && record.packagetype.toUpperCase() === 'CUSTOM') {
            myPkgText += ' (';
            if (record.weblink.toUpperCase() === 'YES') {
                myPkgText += 'WebLink, ';
            }
            if (record.prereglist.toUpperCase() === 'YES') {
                myPkgText += 'PreRegList, ';
            }

            if (myPkgText !== 'Custom (') {
                myPkgText = myPkgText.slice(0, -2) + '): ' + USDollar.format(record.packageamount);
            }
            else {
                myPkgText = myPkgText.slice(0, -2) + ': ' + USDollar.format(record.packageamount);
            }
        }
        else {
            myPkgText += ': ' + USDollar.format(record.packageamount);
        }

        return myPkgText;
    }

    const convertShowColumns = [
        {
            dataIndex: 'showcode',
            title: 'Show Code',
            key: 'showcode'
        }, {
            dataIndex: 'name',
            title: 'Show Name',
            key: 'name'
        }, {
            title: 'Lead Retrieval',
            key: 'lr',
            render: (record) => (
                renderModelAfterLR(record)),
        }, {
            title: 'Package Details',
            key: 'pkg',
            render: (record) => (
                renderModelAfterPackageDetails(record)),
        }
    ].filter(item => !item.hidden);

    const onSelectChangeModelAfter = (newSelectedModelAfterRowKeys) => {
        setSelectedModelAfterRowKeys(newSelectedModelAfterRowKeys);
    };

    const rowSelectionModelAfter = {
        selectedRowKeys: selectedModelAfterRowKeys,
        onChange: onSelectChangeModelAfter,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    function handleExportLeads(e, record) {
        var myLeadsDay;
        var myFileName;

        myLeadsDay = "all";
        myFileName = "D2PLeads_" + record.name.replace(' ', '_') + "_both_days";

        const key = "loading";
        message.loading({
            content: 'Downloading leads...',
            key,
            duration: 0,
        });

        let postdata = {
            exhibitorid: props.selectedCustomerId,
            showcode: parseInt(record.showcode),
            showName: record.name,
            whichday: myLeadsDay
        }

        Axios.post(`/api/DownloadCollectedLeads_XLSX`, postdata, {
            responseType: 'blob'
        }).then(response => {
            console.log(response);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = myFileName + ".xlsx";
            a.click();
            window.URL.revokeObjectURL(url);

            message.destroy(key);
        }).catch(error => {
            console.log(error);
        });
    }

    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    function getPreviousYesShow(selectedShowCode) {
        // Find the index of the selected show
        const index = shows.findIndex(s => s.showcode === selectedShowCode);
        if (index === -1) return null;

        // Look backwards for previous "Yes" but it's actually next (further down) in the list
        for (let i = index + 1; i < shows.length; i++) {
            if (shows[i].salesstatus === "Yes") {
                return shows[i]; // ? return the full object
            }
        }

        return null; // no previous "Yes" found
    }

    function convertYesNoToBool(value) {
        if (value === 'Yes') {
            return true;
        }
        else {
            return false;
        }
    }

    function loadShowDetails(e, record) {
        var mylrFreeOrCharge;
        var myfpFreeOrCharge;
        var mynslFreeOrCharge;

        
        if (record.salesstatus === 'Closed') {
            setAlreadyClosed(true);
        }
        else {
            setAlreadyClosed(false);
        }

        if (['Interested', 'Suspect', 'Prospect', 'Qualified', 'Closing', 'Closed', 'No', 'Till', 'Renewal', null].includes(record.salesstatus)) {
            //LoadServiceCategories();

            const mainContact = contactsListData.find(
                (contact) => contact.contact_type === "Main"
            );

            if (record.salesstatus !== null) {
                setValue('formFields.changestatus.salesstatus', record.salesstatus);
            }
            else {
                setValue('formFields.changestatus.salesstatus', 'Select');
            }
            setValue('formFields.changestatus.reason', '');
            setValue('formFields.convertshow.booth1', '');
            setValue('formFields.convertshow.booth2', '');
            setValue('formFields.convertshow.booth3', '');
            setValue('formFields.convertshow.booth4', '');
            //setValue('formFields.exhibitor.jsS_Category1', '');
            //setValue('formFields.exhibitor.jsS_Category2', '');
            //setValue('formFields.exhibitor.jsS_Category3', '');
            //setValue('formFields.exhibitor.jsS_Category4', '');
            //setValue('formFields.exhibitor.jsS_Category5', '');
            setValue('formFields.selectedPackageType', '');

            //this goes out to get the prior show the Exhibitor was a 'Yes', if there is one, and sets
            //all the Selected Features to the same selections from that show
            let previousYesShow = getPreviousYesShow(record.showcode);

            setPreviousShowName(previousYesShow ? previousYesShow.name : '');

            /*console.log(previousYesShow);*/

            //per post in proj mgr on 4/29/2026 by BLebo, if an add-on is selected for the show we default to 'Charge' for that add-on
            //also, we are porting to FEP if FEP, Weblink or Sponsorship was selected in the previous show
            //https://git.d2p.support/blebo/automated-concepts-support/-/issues/224#note_59658
            if (record.salesstatus === 'Closed') {
                //console.log(record);

                setPreviousShowName('Prior Selections');

                //sales status already closed so load the values from the [show detail] record instead of last 'Yes' show
                setValue('formFields.convertshow.booth1', record.booth1);
                setValue('formFields.convertshow.booth2', record.booth2);
                setValue('formFields.convertshow.booth3', record.booth3);
                setValue('formFields.convertshow.booth4', record.booth4);  

                setValue('formFields.leadretrieval', convertYesNoToBool(record.leadretrievalstatus));
                if (convertYesNoToBool(record.leadretrievalstatus)) {
                    if (record.leadretrievalamount > 0) {
                        mylrFreeOrCharge = 'Charge';
                    }
                    else {
                        mylrFreeOrCharge = 'Free';
                    }
                }
                else {
                    mylrFreeOrCharge = '';
                }

                setValue('formFields.featuredpackage', convertYesNoToBool(record.featuredpackage));
                if (convertYesNoToBool(record.featuredpackage)) {
                    if (record.featuredpackageamount > 0) {
                        myfpFreeOrCharge = 'Charge';
                    }
                    else {
                        myfpFreeOrCharge = 'Free';
                    }
                }
                else {
                    myfpFreeOrCharge = '';
                }

                setValue('formFields.noshowleads', convertYesNoToBool(record.prereglist));
                if (convertYesNoToBool(record.prereglist)) {
                    if (record.prereglistamount > 0) {
                        mynslFreeOrCharge = 'Charge';
                    }
                    else {
                        mynslFreeOrCharge = 'Free';
                    }
                }
                else {
                    mynslFreeOrCharge = '';
                }
            }
            else if (previousYesShow) {
                setValue('formFields.leadretrieval', convertYesNoToBool(previousYesShow.leadretrievalstatus));
                setValue('formFields.weblink', convertYesNoToBool(previousYesShow.weblink));
                setValue('formFields.sponsorship', previousYesShow.sponsorship);

                if (previousYesShow.leadretrievalstatus === 'Yes') {
                    mylrFreeOrCharge = 'Charge';
                }
                else {
                    mylrFreeOrCharge = '';
                }

                setValue('formFields.featuredpackage', convertYesNoToBool(previousYesShow.featuredpackage) || convertYesNoToBool(previousYesShow.weblink) || previousYesShow.sponsorship);
                if (previousYesShow.featuredpackage === 'Yes' || previousYesShow.weblink === 'Yes' || previousYesShow.sponsorship === true) {
                    myfpFreeOrCharge = 'Charge';
                }
                else {
                    myfpFreeOrCharge = '';
                }

                setValue('formFields.noshowleads', convertYesNoToBool(previousYesShow.prereglist));
                if (previousYesShow.prereglist === 'Yes') {
                    mynslFreeOrCharge = 'Charge';
                }
                else {
                    mynslFreeOrCharge = '';
                }
            }
            else {
                setValue('formFields.leadretrieval', false);
                setValue('formFields.featuredpackage', false);
                setValue('formFields.noshowleads', false);

                mylrFreeOrCharge = '';
                myfpFreeOrCharge = '';
                mynslFreeOrCharge = '';
            }

            setValue('formFields.changetomaincontact', false);
            setValue('formFields.renewal', false);

            setState({
                ...state,
                selectedCustomerId: state.selectedCustomerId,
                selectedShowCode: record.showcode,
                selectedShowName: record.name,
                exhibitorType: '',
                showShowDetailSlider: false,
                showShowLogisticsSlider: false,
                showChangeShowStatusModal: true,
                mainContact: mainContact.jsS_name,
                selectedShowInvoiced: hasShowBeenInvoiced(record.invoiced),
                lrFreeOrCharge: mylrFreeOrCharge,
                fpFreeOrCharge: myfpFreeOrCharge,
                nslFreeOrCharge: mynslFreeOrCharge
            });
        }
        else {
            setState({
                ...state,
                selectedCustomerId: state.selectedCustomerId,
                selectedShowCode: record.showcode,
                selectedShowName: record.name,
                showConvertInterestedShowModal: false,
                showShowLogisticsSlider: false,
                showShowDetailSlider: true
            });
        }
    }
    function LoadServiceCategories() {
        let postdata = {};
        postdata.jobshopdivision = userInfo.jobShopDivision

        Axios.get(`/api/GetAllServiceCategories`, {
            params: {
                    
            }
        }).then(response => {
            let servicecategories = response.data.servicecategories;

            setValue("formFields.categories", servicecategories);

        }).catch(error => {
            console.log(error);
        });
    }
    function loadShowLogistics(e, record) {
        if (record.myJobShopShowFlag) {
            setState({
                ...state,
                selectedShowCode: record.showcode,
                showShowDetailSlider: false,
                showShowLogisticsSlider: true
            });
        }
        else {
            setState({
                ...state,
                selectedShowCode: record.showcode,
                showShowDetailSlider: false,
                showShowLogisticsSlider: false
            });

            toast.error('Show is not active on myshowonline.com yet');
            return;
        }
    }
    function loadARDetails(e, record) {
        //console.log(record);
        //if (record.invoiced === null || record.invoiced === false) {
        //    toast.info("Show has not been invoiced yet");
        //    return;
        //}

        setState({
            ...state,
            selectedShowCode: record.showcode,
            selectedShowName: record.name,
            showShowDetailSlider: false,
            showShowARDetailsSlider: true
        });
    }

    function loadBoothFurnishings(e, record) {
        toast.info("Booth Furnishings View Coming Soon!");

        setState({
            ...state,
            showShowDetailSlider: false
        });
    }

    function loadShowBadgesSlider(e, record) {
        Axios.get(`/api/GetExhibitorsForSuppliedServicesManager`, {
            params: {
                showcode: record.showcode,
                filters: 'SelectedCustomerId:' + props.selectedCustomerId
            }
        }).then(response => {
            let exhibitors = response.data;

            setState({
                ...state,
                selectedShowCode: record.showcode,
                showShowDetailSlider: false,
                exhibitors,
                printBadgesMode: 'Single',
                selectedIndex: 0,
                badgesSliderCallingComponent: 'ShowDetailInfo',
                showToPrintBadgesFor: record,
                showShowBadgesSlider: true
            });

        }).catch(error => {
            console.log(error);
        });
    }

    function searchShows(value) {
        let searchMatches = [];
        var currShow;
        var valueCleared = false;
        for (let i = 0; i < shows.length; i++) {
            currShow = shows[i];

            if (value !== '') {
                if ((currShow.name !== null && currShow.name.toLowerCase().includes(value.toLowerCase())) ||
                    (currShow.salesstatus !== null && currShow.salesstatus.toLowerCase().includes(value.toLowerCase())) ||
                    (currShow.booth1 !== null && currShow.booth1.toLowerCase().includes(value.toLowerCase())) ||
                    (currShow.startdate !== null && Moment(dateWithNoTimezone(currShow.startdate)).format("L") === value)) {

                    searchMatches = [...searchMatches, shows[i]];
                }
            }
            else {
                valueCleared = true;
            }
        }

        setfilteredShows(valueCleared ? [...shows] : [...searchMatches]);
    }

    function searchValueChanged(e) {
        setState({
            ...state,
            searchValue: e.target.value,
            showShowDetailSlider: false
        });
    }

    function setSelectedShowCode(selectedShow) {
        hideSelectShowModal();

        let postdata = {};
        postdata.exhibitorid = props.selectedCustomerId;
        postdata.showcode = selectedShow;

        addShowInterest(postdata).then(data => {
            if (data === 'OK') {
                toast.success('Selected show added to list of shows for this exhibitor');
                getCustomerShows(props.selectedCustomerId);
            }
            else {
                toast.error(data);
                return;
            }
        });
    }

    function hideSelectShowModal() {
        setTimeout(() => {
            setState({
                ...state,
                showSelectShowModal: false
            });
        }, 1000);
    }

    function handleAddInterest() {
        setState({
            ...state,
            modalTitle: 'Add Show Interest',
            showSelectShowModal: true
        });
    }

    function onSave() {
        if (getValues().formFields.changestatus.salesstatus === 'Select') {
            toast.error('A New Sales Status Must Be Selected');
            return;
        }

        console.log(alreadyClosed);

        if (getValues().formFields.changestatus.salesstatus === 'Closed') {
            if (screenDataOKToChangeToClosed() === false) {
                return;
            }

            if (handleProcessSalesOrder() === "OK") {
                setState({
                    ...state,
                    showChangeShowStatusModal: false
                });
            };
        }
        else {
            if (handleProcessSalesStatusChange() === "OK") {
                setState({
                    ...state,
                    showChangeShowStatusModal: false
                });
            }
        }
    }

    function handleProcessSalesStatusChange() { 
        let postdata = {};
        let show = {};

        show.id = props.selectedCustomerId;
        show.showcode = state.selectedShowCode;
        show.salesstatus = getValues().formFields.changestatus.salesstatus;

        postdata.show = show;
        postdata.showName = state.selectedShowName;
        postdata.userid = userInfo.userId;
        postdata.content = getValues().formFields.changestatus.reason;

        updateSalesStatus(postdata).then(data => {
            if (data === 'OK') {
                toast.success('Show status successfully updated');
                return "OK";
            }
            else {
                data = "<strong>Sales Status Cannot Be Changed</strong><br />" + data;
                toast.error(<span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: data }}></span>, { alignment: 'top-center', duration: 5 })
                return "NOT PROCESSED";
            }
        });
    }

    function handleProcessSalesOrder() {
        var exhibitortype = "";

        if (state.totalYesShows > 0) {
            exhibitortype = "Current Exhibitor";
        }
        else {
            exhibitortype = "New Exhibitor";
        }

        let postdata = {};

        postdata.id = props.selectedCustomerId;
        postdata.exhibitorname = props.selectedCustomerName;
        postdata.showcode = state.selectedShowCode;
        postdata.showname = state.selectedShowName;
        postdata.salesstatus = getValues().formFields.changestatus.salesstatus;
        postdata.userid = userInfo.userId;
        postdata.reason = getValues().formFields.changestatus.reason;
        postdata.booth1 = getValues().formFields.convertshow.booth1;
        postdata.booth2 = getValues().formFields.convertshow.booth2;
        postdata.booth3 = getValues().formFields.convertshow.booth3;
        postdata.booth4 = getValues().formFields.convertshow.booth4;
        postdata.exhibitortype = exhibitortype;
        postdata.leadretrieval = getValues().formFields.leadretrieval;
        postdata.lrfreeorcharge = state.lrFreeOrCharge
        postdata.featuredexhibitorpackage = getValues().formFields.featuredpackage;
        postdata.fpfreeorcharge = state.fpFreeOrCharge;
        postdata.noshowleads = getValues().formFields.noshowleads;
        postdata.nslfreeorcharge = state.nslFreeOrCharge;
        postdata.othercontacttoreceiveinvoice = state.selectedContactName;
        postdata.changeothercontacttomain = getValues().formFields.changetomaincontact;
        postdata.renewal = getValues().formFields.renewal;

        processSalesOrder(postdata).then(data => {
            if (data === 'OK') {
                toast.success('Show status successfully updated and customer service has been notified');
                return "OK";
            }
            else {
                data = "<strong>Sales Order Was Not Processed</strong><br />" + data;
                toast.error(<span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: data }}></span>, { alignment: 'top-center', duration: 5 })
                return "NOT PROCESSED";
            }
        });
    }

    //function handleSubmitWorkflowRequest() {
    //    if (screenDataOK() === false) {
    //        return;
    //    }

    //    let wfStateInitial = {};
    //    wfStateInitial.searchFormInitialState = state.searchFormInitialState;

    //    let wfState = {};
    //    wfState.searchForm = {
    //        selectedShow: getValues().formFields.selectedShow,
    //        selectedSalesStatus: getValues().formFields.selectedSalesStatus,
    //        selectedPackageType: getValues().formFields.selectedPackageType,
    //        booth: getValues().formFields.booth,
    //        weblink: getValues().formFields.weblink,
    //        noshowleads: getValues().formFields.noshowleads,
    //        leadretrieval: getValues().formFields.leadretrieval,
    //        notes: getValues().formFields.notes
    //    };

    //    let postdata = {
    //        originatorUsername: userInfo.userId,
    //        company_Id: props.selectedCustomerId,
    //        itemDetail: "Process JSS Sales Order",
    //        oldValue: JSON.stringify(wfStateInitial),
    //        newValue: JSON.stringify(wfState)
    //    }

    //    insertNewWorklistItem(postdata).then(data => {
    //        if (data) {
    //            toast.success("Sales Order submitted successfully");

    //            setState({
    //                ...state,
    //                showPane: false
    //            });
    //        } else {
    //            toast.error("Something went wrong");
    //        }
    //    }).catch(error => {
    //        toast.error("Something went wrong");
    //    });  
    //}

    function hideChangeShowStatusModal() {
        setState({
            ...state,
            showChangeShowStatusModal: false
        });
    }
    
    //function handleExhibitorTypeChange(e) {
    //    setState({
    //        ...state,
    //        exhibitorType: e.target.value
    //    });
    //}

    function handleLRFreeOrChargeChange(e) {
        setState({
            ...state,
            lrFreeOrCharge: e.target.value
        });
    }

    function handleFPFreeOrChargeChange(e) {
        setState({
            ...state,
            fpFreeOrCharge: e.target.value
        });
    }

    function handleNSLFreeOrChargeChange(e) {
        setState({
            ...state,
            nslFreeOrCharge: e.target.value
        });
    }

    function screenDataOKToChangeToClosed() {
        let errString = '';

        if (state.selectedShowInvoiced && getValues().formFields.convertshow.booth1.trim() === '') {
            errString += 'Booth 1 must be provided since the show has already been invoiced<br />';
        }

        if (getValues().formFields.leadretrieval === true && state.lrFreeOrCharge === '') {
            errString += 'You must specify if Lead Retrieval is Free or Charge<br />';
        }
        if (getValues().formFields.featuredpackage === true && state.fpFreeOrCharge === '') {
            errString += 'You must specify if Featured Exhibitor Package is Free or Charge<br />';
        }
        if (getValues().formFields.noshowleads === true && state.nslFreeOrCharge === '') {
            errString += 'You must specify if No Show Leads is Free or Charge<br />';
        }

        if (errString !== '') {
            var htmlErrorContent = <div dangerouslySetInnerHTML={{ __html: errString }} />

            toast.error(htmlErrorContent);
            return false;
        }
        else {
            return true;
        }
    }

    function handleOptionsChange(event) {
        var mylrFreeOrCharge = state.lrFreeOrCharge;
        var myfpFreeOrCharge = state.fpFreeOrCharge;
        var mynslFreeOrCharge = state.nslFreeOrCharge;

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        switch (target.name) {
            case "formFields.leadretrieval":
                if (value === false) {
                    mylrFreeOrCharge = '';
                }
                break;

            case "formFields.noshowleads":
                if (value === false) {
                    mynslFreeOrCharge = '';
                }
                break;

            case "formFields.featuredpackage":
                if (value === false) {
                    myfpFreeOrCharge = '';
                }
                break;

            default:
        }

        setValue(target.name, value);

        setState({
            ...state,
            lrFreeOrCharge: mylrFreeOrCharge,
            nslFreeOrCharge: mynslFreeOrCharge,
            fpFreeOrCharge: myfpFreeOrCharge
        });
    }

    const onContactChange = (event) => {
        var selectedContactName = "";

        const selectedId = event.target.value; // contact_id from <option value="">

        if (!selectedId) {
            selectedContactName = "";
        }

        // Find the matching contact
        const selectedContact = contactsListData.find(
            (contact) => contact.contact_id.toString() === selectedId
        );

        if (selectedContact) {
            selectedContactName = selectedContact.jsS_name;
        }

        setState({
            ...state,
            selectedContactName: selectedContactName
        });
    };

    function hasShowBeenInvoiced(date) {
        if (!date) {
            return false; // or handle null as you wish
        }

        const incoming = new Date(date);
        const today = new Date();

        // Strip time (so comparison is date-only, not including hours/minutes/seconds)
        incoming.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return incoming < today;
    }

    function hideShowARDetailsSlider() {
        setTimeout(() => {
            setState({
                ...state,
                showShowARDetailsSlider: false
            });
        }, 1000);
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <Spin spinning={!state.dataLoaded}>
                    <div style={!state.dataLoaded ? {} : { display: 'none' }}>
                        <Alert
                            message="Loading Show Details"
                            description="Please stand by while we retrieve show information for this customer"
                            type="info"
                        />
                    </div>
                    {state.dataLoaded &&
                        <div className="row">
                            <h5 className="frame-heading mt-3">
                                -- SHOW DETAIL INFO --
                            </h5>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <Input.Search
                                    style={{ paddingTop: "20px", margin: "0 0 10px 0", width: "90%" }}
                                    placeholder="Search shows by show name, date, sales status or booth # ..."
                                    enterButton
                                    onSearch={searchShows}
                                    allowClear
                                    value={state.searchValue}
                                    onChange={searchValueChanged}
                                />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 text-left pt-1">
                                <p class="text-left"><Button className="mt-3" type="btn btn-submit" onClick={handleAddInterest}>Add Show Status</Button></p>
                            </div>

                            <div className="col-sm-10 col-md-10 col-lg-10">
                                {filteredShows.length === 0 ?
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                        <span>
                                            No Show Information Found
                                        </span>
                                    } />
                                    :
                                    <Table className="custom-ant-selection"
                                        rowKey={item => item.showcode}
                                        rowSelection={rowSelection}
                                        hideSelectionColumn={true}
                                        bordered
                                        dataSource={filteredShows}
                                        columns={columns}
                                        pagination={{
                                            defaultPageSize: 10,
                                            showSizeChanger: true,
                                            pageSizeOptions: ['10', '25', '50', '100'],
                                            showTotal: (total, range) => (
                                                <span className="color-dark-blue" style={{ left: 0, position: "absolute", fontSize: "large", fontWeight: "bold" }}>
                                                    Showing {range[0]}-{range[1]} of {total}
                                                </span>
                                            )
                                        }}
                                        onRow={(record) => {
                                            return {
                                                onClick: () => {
                                                    let selRows = [record.showcode];
                                                    setSelectedRowKeys([...selRows]);

                                                    return;
                                                },
                                                onDoubleClick: (e) => {
                                                    loadShowDetails(e, record);
                                                }
                                            }
                                        }}
                                    />
                                }
                            </div>
                            <div className="col-sm-2 col-md-2 col-lg-2 text-left">
                                {state.shows.length > 0 &&
                                    <div>
                                        <table style={{ border: 'solid thin navy', padding: '10px' }}>
                                            <tbody>
                                                <tr><td colSpan="2" style={{ paddingLeft: '10px', paddingRight: '10px', fontWeight: 'bold' }}>Show Summary</td></tr>
                                                <tr><td style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: '10px' }} colSpan="2">First Show: {state.firstShow}</td></tr>
                                                <tr><td style={{ paddingLeft: '10px' }}>Yes:</td><td className="text-right" style={{ paddingRight: '10px' }}>{state.totalYesShows}</td></tr>
                                                <tr><td style={{ paddingLeft: '10px' }}>Cancel:</td><td className="text-right" style={{ paddingRight: '10px' }}>{state.totalCancelShows}</td></tr>
                                                <tr><td style={{ paddingLeft: '10px' }}>No:</td><td className="text-right" style={{ paddingRight: '10px' }}>{state.totalNoShows}</td></tr>
                                                <tr><td style={{ paddingLeft: '10px' }}>Other:</td><td className="text-right" style={{ paddingRight: '10px' }}>{state.totalOtherShows}</td></tr>
                                                <tr><td colSpan="2" style={{ paddingLeft: '10px', paddingRight: '10px' }}><hr /></td></tr>
                                                <tr><td style={{ paddingLeft: '10px' }}><strong>Total:</strong></td><td className="text-right" style={{ paddingRight: '10px' }}>{state.totalShows}</td></tr>
                                            </tbody>
                                        </table>

                                        <div style={state.leadsList.length > 0 ? {} : { display: 'none' }}>
                                            <button className="btn btn-submit mt-3" onClick={handleExportLeads}>Download Collected Leads</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </Spin>
            </div>

            {state.showShowDetailSlider &&
                <ShowDetailSlider selectedCustomerId={state.selectedCustomerId} selectedShowCode={state.selectedShowCode} selectedShowName={state.selectedShowName}
                    showPane={state.showShowDetailSlider} hidePane={() => setState({ ...state, showShowDetailSlider: false })} />
            }

            {state.showSelectShowModal &&
                <SelectShowModal showModal={state.showSelectShowModal} modalTitle={state.modalTitle} hideSelectShowModal={hideSelectShowModal} setSelectedShowCode={setSelectedShowCode} />
            }

            {state.showShowLogisticsSlider &&
                <ShowLogisticsSlider selectedCustomerId={state.selectedCustomerId} selectedShowCode={state.selectedShowCode} showDrawer={state.showShowLogisticsSlider} selectedCustomerName={props.selectedCustomerName}
                    hidePane={() => setState({ ...state, showShowLogisticsSlider: false })} />
            }

            {state.showShowBadgesSlider &&
                <ExhibitorBadgesSlider showPane={state.showShowBadgesSlider} exhibitors={state.exhibitors} printBadgesMode={state.printBadgesMode} selectedCustomerId={state.selectedCustomerId}
                    showToPrintBadgesFor={state.showToPrintBadgesFor} hidePane={() => setState({ ...state, showShowBadgesSlider: false })} selectedIndex={state.selectedIndex} badgesSliderCallingComponent={state.badgesSliderCallingComponent} />
            }

            {state.showShowARDetailsSlider &&
                <ShowARDetailsSlider showPane={state.showShowARDetailsSlider} hideShowARDetailsSlider={hideShowARDetailsSlider} selectedCustomerId={state.selectedCustomerId} selectedShowCode={state.selectedShowCode}
                    selectedShowName={state.selectedShowName} hidePane={() => setState({ ...state, showShowARDetailsSlider: false })} />
            }

            {state.showChangeShowStatusModal &&
                <Modal
                    visible={state.showChangeShowStatusModal}
                    title='Change Sales Status'
                    onCancel={hideChangeShowStatusModal}
                    width='800px'
                    footer={[
                        <button className="btn btn-submit" onClick={onSave}>
                            Save
                        </button>,
                        <span>&nbsp;&nbsp;</span>,
                        <button className="btn btn-outline-primary" onClick={hideChangeShowStatusModal}>
                            Close
                        </button>
                    ]}
                >
                    <div className="row">
                        <div className="form-group col-lg-12">
                            <label className="form-label">Sales Status Change For: {state.selectedShowName}</label>
                        </div>

                        <div className="form-group col-lg-12">&nbsp;</div>

                        <div className="form-group col-lg-4">
                            <label className="form-label">Select New Status</label>
                            <select className="form-control-custom" {...register("formFields.changestatus.salesstatus")}>
                                <option value="Select">Select</option>
                                <option value="Closed">Closed</option>
                                <option value="Closing">Closing</option>
                                <option value="Suspect">Suspect</option>
                                <option value="Prospect">Prospect</option>
                                <option value="Qualified">Qualified</option>
                                <option value="Renewal">Renewal</option>
                                <option value="No">No</option>
                            </select>

                            {salesStatus === 'Closed' &&
                                <div className="custom-control custom-checkbox mt-2">
                                    <input type="checkbox" className="custom-control-input" name="renewal" {...register("formFields.renewal")} checked={getValues().formFields.enewal} onChange={handleOptionsChange} />
                                    <label className="custom-control-label" style={{ fontWeight: 600 }}>This is a Renewal</label>
                                </div>
                            }
                        </div>
                        <div className="form-group col-lg-2"></div>

                        {salesStatus === 'Closed' ? (
                            <div className="form-group col-lg-6">
                                <div className="pt-3 pb-2"><strong>Main Contact:</strong> {state.mainContact}</div>

                                <label className="form-label">Select Another Contact To Receive Invoice</label><br />
                                <select id="ddContacts" onChange={onContactChange}>
                                    <option value="">-- Select --</option>
                                    {contactsListData
                                        .filter((contact) => contact.contact_type !== "Main")
                                        .map((contact) => (
                                            <option key={contact.contact_id} value={contact.contact_id}>
                                                {contact.jsS_name} ({contact.contact_type})
                                            </option>
                                        ))}
                                </select>
                                {/*<select id="ddContacts" onChange={onContactChange}>*/}
                                {/*    {contactsListData.map((contact) => <option key={contact.contact_id} value={contact.contact_id}>{contact.jsS_name} ({contact.contact_type})</option>)}*/}
                                {/*</select>*/}

                                {state.selectedContactName !== '' &&
                                    <div className="custom-control custom-checkbox mt-2">
                                        <input type="checkbox" className="custom-control-input" name="changetomaincontact" {...register("formFields.changetomaincontact")} checked={getValues().formFields.changetomaincontact} onChange={handleOptionsChange} />
                                        <label className="custom-control-label" style={{ fontWeight: 600 }}>Change This Contact To The Main Contact</label>
                                    </div>
                                }
                            </div>
                        ) : (
                                <div className="form-group col-lg-6"></div>
                        )}
                        
                        <div className="form-group col-lg-12">&nbsp;</div>

                        <div className="form-group col-lg-12">
                            <label className="form-label">Additional Notes or Comments</label>
                            <textarea name="reason" {...register("formFields.changestatus.reason")} className="form-control-custom" rows={4} />
                        </div>

                        {salesStatus === 'Closed' &&
                            <>
                            {/*<div className="row">
                                    <div onChange={handleExhibitorTypeChange}>
                                        <label className="form-label">Type of Exhibitor:</label>&nbsp;&nbsp;
                                        <input type="radio" name="exhibitorType" value="Current Exhibitor" className="mt-1" checked={state.exhibitorType === 'Current Exhibitor'} />&nbsp;<label className="form-label">Current Exhibitor</label>&nbsp;&nbsp;&nbsp;
                                        <input type="radio" name="exhibitorType" value="New Exhibitor" className="mt-1" checked={state.exhibitorType === 'New Exhibitor'} />&nbsp;<label className="form-label">New Exhibitor</label>&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>*/}
                                <div className="col-sm-12 col-md-6 col-xl-6">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Booths</span></Card.Header>
                                        <Card.Body>
                                            <div className="col-12 d-inline-flex mb-2">
                                                <label className="form-label">Booth 1:&nbsp;</label>
                                                <input type="text" name="booth1" {...register("formFields.convertshow.booth1")} className="form-control-custom flex-fill w-unset text-truncate" />
                                            </div>
                                            <div className="col-12 d-inline-flex mb-2">
                                                <label className="form-label">Booth 2:&nbsp;</label>
                                                <input type="text" name="booth2" {...register("formFields.convertshow.booth2")} className="form-control-custom flex-fill w-unset text-truncate" />
                                            </div>
                                            <div className="col-12 d-inline-flex mb-2">
                                                <label className="form-label">Booth 3:&nbsp;</label>
                                                <input type="text" name="booth3" {...register("formFields.convertshow.booth3")} className="form-control-custom flex-fill w-unset text-truncate" />
                                            </div>
                                            <div className="col-12 d-inline-flex mb-2">
                                                <label className="form-label">Booth 4:&nbsp;</label>
                                                <input type="text" name="booth4" {...register("formFields.convertshow.booth4")} className="form-control-custom flex-fill w-unset text-truncate" />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>


                                <div className="col-sm-12 col-md-6 col-xl-6">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Selected Features</span></Card.Header>
                                        <Card.Body>
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input" name="leadretrieval" {...register("formFields.leadretrieval")} checked={getValues().formFields.leadretrieval} onChange={handleOptionsChange} />
                                                <label className="custom-control-label" style={{ fontWeight: 600 }}>Lead Retrieval</label>
                                            </div>
                                            <div onChange={handleLRFreeOrChargeChange}>
                                                <input type="radio" name="lrFreeOrCharge" value="Free" className="mt-1" checked={state.lrFreeOrCharge === 'Free'} />&nbsp;<label className="form-label">Free</label>&nbsp;&nbsp;&nbsp;
                                                <input type="radio" name="lrFreeOrCharge" value="Charge" className="mt-1" checked={state.lrFreeOrCharge === 'Charge'} />&nbsp;<label className="form-label">Charge</label>
                                            </div>

                                            {/*{state.selectedShowCode <= 403 ? (*/}
                                            {/*    <div className="pt-3">*/}
                                            {/*        <div className="custom-control custom-checkbox">*/}
                                            {/*            <input type="checkbox" className="custom-control-input" name="weblink" {...register("formFields.weblink")} checked={getValues().formFields.weblink} onChange={handleOptionsChange} />*/}
                                            {/*            <label className="custom-control-label" style={{ fontWeight: 600 }}>Weblink</label>*/}
                                            {/*        </div>*/}
                                            {/*        <div onChange={handleWLFreeOrChargeChange}>*/}
                                            {/*            <input type="radio" name="wlFreeOrCharge" value="Free" className="mt-1" checked={state.wlFreeOrCharge === 'Free'} />&nbsp;<label className="form-label">Free</label>&nbsp;&nbsp;&nbsp;*/}
                                            {/*            <input type="radio" name="wlFreeOrCharge" value="Charge" className="mt-1" checked={state.wlFreeOrCharge === 'Charge'} />&nbsp;<label className="form-label">Charge</label>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*): (*/}
                                            {/*    <div className = "pt-3">*/}
                                            {/*        <div className = "custom-control custom-checkbox">*/}
                                            {/*            <input type = "checkbox" className = "custom-control-input" name = "featuredpackage" {...register("formFields.featuredpackage")} checked={getValues().formFields.featuredpackage} onChange={handleOptionsChange} />*/}
                                            {/*            <label className="custom-control-label" style={{ fontWeight: 600 }}>Featured Exhibitor Package</label>*/}
                                            {/*        </div>*/}
                                            {/*        <div onChange={handleFPFreeOrChargeChange}>*/}
                                            {/*            <input type="radio" name="fpFreeOrCharge" value="Free" className="mt-1" checked={state.fpFreeOrCharge === 'Free'} />&nbsp;<label className="form-label">Free</label>&nbsp;&nbsp;&nbsp;*/}
                                            {/*            <input type="radio" name="fpFreeOrCharge" value="Charge" className="mt-1" checked={state.fpFreeOrCharge === 'Charge'} />&nbsp;<label className="form-label">Charge</label>*/}
                                            {/*        </div>*/}
                                            {/*    </div> */}
                                            {/*)}*/}

                                            <div className="pt-3">
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" name="featuredpackage" {...register("formFields.featuredpackage")} checked={getValues().formFields.featuredpackage} onChange={handleOptionsChange} />
                                                    <label className="custom-control-label" style={{ fontWeight: 600 }}>Featured Exhibitor Package</label>
                                                </div>
                                                <div onChange={handleFPFreeOrChargeChange}>
                                                    <input type="radio" name="fpFreeOrCharge" value="Free" className="mt-1" checked={state.fpFreeOrCharge === 'Free'} />&nbsp;<label className="form-label">Free</label>&nbsp;&nbsp;&nbsp;
                                                    <input type="radio" name="fpFreeOrCharge" value="Charge" className="mt-1" checked={state.fpFreeOrCharge === 'Charge'} />&nbsp;<label className="form-label">Charge</label>
                                                </div>
                                            </div> 
                                            <div className="pt-3">
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" name="noshowleads" {...register("formFields.noshowleads")} checked={getValues().formFields.noshowleads} onChange={handleOptionsChange} />
                                                    <label className="custom-control-label" style={{ fontWeight: 600 }}>No Show Leads</label>
                                                </div>
                                                <div onChange={handleNSLFreeOrChargeChange}>
                                                    <input type="radio" name="nslFreeOrCharge" value="Free" className="mt-1" checked={state.nslFreeOrCharge === 'Free'} />&nbsp;<label className="form-label">Free</label>&nbsp;&nbsp;&nbsp;
                                                    <input type="radio" name="nslFreeOrCharge" value="Charge" className="mt-1" checked={state.nslFreeOrCharge === 'Charge'} />&nbsp;<label className="form-label">Charge</label>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                    <div>
                                        {previousShowName
                                            ? `Features Loaded From: ${previousShowName}`
                                            : 'No Prior Yes Show Found'}
                                    </div>

                                {/*<Card className="d2pCard mb-3">*/}
                                    {/*    <Card.Header><span>Service Categories</span></Card.Header>*/}
                                    {/*    <Card.Body>*/}
                                    {/*        <div className="col-12 d-inline-flex mb-2">*/}
                                    {/*            <label className="form-label me-2">Maj Cat:</label>*/}
                                    {/*            <Select value={getValues().formFields.exhibitor.jsS_Category1} onSelect={(value) => handleSelectChange("formFields.exhibitor.jsS_Category1", value)} onClear={() => handleSelectClear("formFields.exhibitor.jsS_Category1")} className="form-control-custom flex-fill w-unset text-truncate" mode="single" placeholder="Maj Category" bordered={false} allowClear disabled={viewOnly} >*/}
                                    {/*                {getValues().formFields.categories?.map((cat) => <Option key={cat.category} value={cat.categoryName}>{cat.categoryName}</Option>)}*/}
                                    {/*            </Select>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="col-12 d-inline-flex mb-2">*/}
                                    {/*            <label className="form-label me-2">2nd Cat:</label>*/}
                                    {/*            <Select value={getValues().formFields.exhibitor.jsS_Category2} onSelect={(value) => handleSelectChange("formFields.exhibitor.jsS_Category2", value)} onClear={() => handleSelectClear("formFields.exhibitor.jsS_Category2")} className="form-control-custom flex-fill w-unset text-truncate" mode="single" placeholder="2nd Category" bordered={false} allowClear disabled={viewOnly} >*/}
                                    {/*                {getValues().formFields.categories?.map((cat) => <Option key={cat.category} value={cat.categoryName}>{cat.categoryName}</Option>)}*/}
                                    {/*            </Select>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="col-12 d-inline-flex mb-2">*/}
                                    {/*            <label className="form-label me-2">3rd Cat:</label>*/}
                                    {/*            <Select value={getValues().formFields.exhibitor.jsS_Category3} onSelect={(value) => handleSelectChange("formFields.exhibitor.jsS_Category3", value)} onClear={() => handleSelectClear("formFields.exhibitor.jsS_Category3")} className="form-control-custom flex-fill w-unset text-truncate" mode="single" placeholder="3rd Category" bordered={false} allowClear disabled={viewOnly} >*/}
                                    {/*                {getValues().formFields.categories?.map((cat) => <Option key={cat.category} value={cat.categoryName}>{cat.categoryName}</Option>)}*/}
                                    {/*            </Select>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="col-12 d-inline-flex mb-2">*/}
                                    {/*            <label className="form-label me-2">4th Cat:</label>*/}
                                    {/*            <Select value={getValues().formFields.exhibitor.jsS_Category4} onSelect={(value) => handleSelectChange("formFields.exhibitor.jsS_Category4", value)} onClear={() => handleSelectClear("formFields.exhibitor.jsS_Category4")} className="form-control-custom flex-fill w-unset text-truncate" mode="single" placeholder="4th Category" bordered={false} allowClear disabled={viewOnly} >*/}
                                    {/*                {getValues().formFields.categories?.map((cat) => <Option key={cat.category} value={cat.categoryName}>{cat.categoryName}</Option>)}*/}
                                    {/*            </Select>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="col-12 d-inline-flex mb-2">*/}
                                    {/*            <label className="form-label me-2">5th Cat:</label>*/}
                                    {/*            <Select value={getValues().formFields.exhibitor.jsS_Category5} onSelect={(value) => handleSelectChange("formFields.exhibitor.jsS_Category5", value)} onClear={() => handleSelectClear("formFields.exhibitor.jsS_Category5")} className="form-control-custom flex-fill w-unset text-truncate" mode="single" placeholder="5th Category" bordered={false} allowClear disabled={viewOnly} >*/}
                                    {/*                {getValues().formFields.categories?.map((cat) => <Option key={cat.category} value={cat.categoryName}>{cat.categoryName}</Option>)}*/}
                                    {/*            </Select>*/}
                                    {/*        </div>*/}
                                    {/*    </Card.Body>*/}
                                    {/*</Card>*/}
                                </div>
                                
                            {/*
                            <div className="form-group col-lg-12">
                                <label className="form-label">Package Type</label>
                                <div>
                                    <input type="radio" name="packageType" value="Basic" className="mt-1" 
                                        onChange={handlePackageTypeChange} 
                                        checked={getValues().formFields.selectedPackageType === 'Basic'} />
                                    &nbsp;<label className="form-label">Basic Package</label>
                                </div>
                                <div>
                                    <input type="radio" name="packageType" value="Custom" className="mt-1" 
                                        onChange={handlePackageTypeChange} 
                                        checked={getValues().formFields.selectedPackageType === 'Custom'} />
                                    &nbsp;<label className="form-label">Custom Package</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-2">
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" name="weblink" 
                                                {...register("formFields.weblink")} 
                                                checked={getValues().formFields.weblink} 
                                                onChange={handleOptionsChange} 
                                                disabled={getValues().formFields.selectedPackageType !== 'Custom' 
                                                    || getValues().formFields.selectedPackageType === null ? true : false} />
                                            <label className="custom-control-label">Weblink</label>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" name="noshowleads" 
                                                {...register("formFields.noshowleads")} 
                                                checked={getValues().formFields.noshowleads} 
                                                onChange={handleOptionsChange} 
                                                disabled={getValues().formFields.selectedPackageType !== 'Custom' 
                                                    || getValues().formFields.selectedPackageType === null ? true : false} />
                                            <label className="custom-control-label">No Show Leads</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            */}
                            </>
                        }
                    </div>
                </Modal>
            }
        </div>
    );
}